module.exports = __webpack_public_path__ + "ca3392bc85ef490ca0edd973ace3f443.svg";